import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { FolderIcon, FileIcon } from 'base/components/Icon/index';
import theme from 'theme/index';
import { textBold } from 'theme/theme';

const FileExtension = styled.div`
  margin-top: -2px;
  color: ${theme.colors.medium};
  text-transform: uppercase;
  text-align: center;
  font-size: 10px;
  ${textBold};
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

const FileIconWithExtension = ({ extension, ...other }) => (
  <Wrapper>
    <FileIcon {...other} />
    <FileExtension>{extension}</FileExtension>
  </Wrapper>
);
FileIconWithExtension.propTypes = {
  extension: PropTypes.string.isRequired,
};

const MimeTypeIcon = ({ mimeType, ...other }) => {
  const iconProps = {
    color: theme.colors.medium,
    size: '23px',
    ...other,
  };
  switch (mimeType) {
    case 'folder':
      return <FolderIcon {...iconProps} />;
    case 'application/pdf':
      return <FileIconWithExtension extension="pdf" {...iconProps} />;
    case 'application/msword':
      return <FileIconWithExtension extension="doc" {...iconProps} />;
    case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
    case 'application/vnd.openxmlformats-officedocument.wordprocessingml.template':
    case 'application/vnd.ms-word.document.macroEnabled.12':
    case 'application/vnd.ms-word.template.macroEnabled.12':
      return <FileIconWithExtension extension="docx" {...iconProps} />;
    case 'application/vnd.ms-excel':
      return <FileIconWithExtension extension="xls" {...iconProps} />;
    case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
    case 'application/vnd.openxmlformats-officedocument.spreadsheetml.template':
    case 'application/vnd.ms-excel.sheet.macroEnabled.12':
    case 'application/vnd.ms-excel.template.macroEnabled.12':
    case 'application/vnd.ms-excel.addin.macroEnabled.12':
    case 'application/vnd.ms-excel.sheet.binary.macroEnabled.12':
      return <FileIconWithExtension extension="xlsx" {...iconProps} />;
    case 'application/vnd.ms-powerpoint':
      return <FileIconWithExtension extension="ppt" {...iconProps} />;
    case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
    case 'application/vnd.openxmlformats-officedocument.presentationml.template':
    case 'application/vnd.openxmlformats-officedocument.presentationml.slideshow':
    case 'application/vnd.ms-powerpoint.addin.macroEnabled.12':
    case 'application/vnd.ms-powerpoint.presentation.macroEnabled.12':
    case 'application/vnd.ms-powerpoint.template.macroEnabled.12':
    case 'application/vnd.ms-powerpoint.slideshow.macroEnabled.12case':
      return <FileIconWithExtension extension="pptx" {...iconProps} />;
    case 'image/jpeg':
      return <FileIconWithExtension extension="jpg" {...iconProps} />;
    default:
      return <FileIcon {...iconProps} />;
  }
};
MimeTypeIcon.propTypes = {
  mimeType: PropTypes.string.isRequired,
};

export default MimeTypeIcon;
